import React from 'react';
import PropTypes from 'prop-types';
import { TitleWrapper, StyledBadge, StyledMake, StyledTitle } from './Styles';

const propTypes = {
  trade: PropTypes.shape({
    make: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    model: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

const defaultProps = {
  trade: {
    make: undefined,
    model: undefined,
    year: undefined,
    id: undefined
  }
};

const Title = ({ trade }) => {
  const { year, make, model, id } = trade;

  return (
    <TitleWrapper>
      {year && <StyledBadge data-testid={`${id}-year`}>{year}</StyledBadge>}
      {make && (
        <StyledMake data-testid={`${id}-make`} className="notranslate">
          {make}
        </StyledMake>
      )}
      {model && (
        <StyledTitle data-testid={`${id}-model`} className="notranslate">
          {model}
        </StyledTitle>
      )}
    </TitleWrapper>
  );
};

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
